import ReactDOM from 'react-dom/client'
import { Filling } from './Filling'

const container = document.getElementById('root')
if (container == null) throw new Error('No container with id "root" found')
const root = ReactDOM.createRoot(container)
root.render(<Filling />)
